<template>
  <div class="row">
    <div class="col-lg-8">
      <div>
        <user-edit-card :user="user" />
      </div>
      <div class="mt-5">
        <user-password-card :user="user" />
      </div>
    </div>
    <div class="col-lg-4">
      <user-card :user="user" ref="usercard" />
    </div>
  </div>
</template>

<script>
import UserEditCard from "@/pages/Dashboard/Examples/UserProfile/EditProfileCard.vue";
import UserPasswordCard from "@/pages/Dashboard/Examples/UserProfile/EditPasswordCard.vue";
import UserCard from "@/pages/Dashboard/Pages/UserProfile/UserCard.vue";

export default {
  name: "user-profile-example",

  components: {
    "user-card": UserCard,
    "user-edit-card": UserEditCard,
    "user-password-card": UserPasswordCard,
  },

  data() {
    return {
      user: {
        type: "profile",
        name: null,
        email: null,
        profile_image: null,
        sw_user: null,
        sw_url: null,
        vtool_settings: null,
      },
      shopLogo: '',
    };
  },

  created() {
    this.getProfile();
  },

  mounted () {
    this.getShopLogo();
    this.getCategoriesStreams();
  },

  methods: {

    async getProfile() {
      await this.$store.dispatch("profile/me");
      this.user = await this.$store.getters["profile/me"];
      console.log('test user getProfile: ', this.user);
    },

    async getCategoriesStreams() {
      await this.$store.dispatch("swapi/get", 'getCategoriesStreams/param:null');
      var test = await this.$store.getters["swapi/swapi"];
      console.log('getCategoriesStreams swapi: ', test);
    },    

    async getShopLogo () {

      await this.$store.dispatch("swapi/get", 'getShopLogo/param:null');
      var response = await this.$store.getters["swapi/swapi"];
      var shopLogoUrl = response.type.data.shopLogoUrl;
      
      if(shopLogoUrl.indexOf('http') !== -1){
       
      } else {
        this.$refs.usercard.setShopLogo(this.user.sw_url + '' + shopLogoUrl);
        shopLogoUrl = 'https://' + this.user.sw_url + '' + shopLogoUrl;
      }
      console.log('getShopLogo swapi: ', shopLogoUrl);
      this.$refs.usercard.setShopLogo(shopLogoUrl);
      

      // await this.$store.dispatch("swapi/list");
      // var sw_data = await this.$store.getters["swapi/list"];
      // console.log('sw_data', sw_data)
      // this.$http.get('https://vtool-api.sw5-sandbox.com/sw-api/getShopLogo.php?shopUrl=' + sw_data.id.data.sw_url).then((resp) => {
      //   this.$refs.usercard.setShopLogo(resp.data); 
      //   console.log('resp.data', resp)
      // })

    },
  },
};
</script>